import { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../auth/msalConfig';
import { useAuthStore } from '../../stores/authStore';
import { useBillingStatus } from './useBillingStatus';

/**
 * `/signup` entry point. Authenticating *is* signup — the tenant auto-provisions
 * on the first authed request. Flow (Pack C):
 *  - Not signed in → `loginRedirect` (External ID sign-up/sign-in).
 *  - Signed in, Active / PastDue-in-grace → `/dashboard`.
 *  - Signed in, no subscription → `/onboarding` (the stepper drives the demo and
 *    Stripe checkout from there). Checkout is no longer auto-started here.
 */
export function SignupEntry() {
  const { instance } = useMsal();
  const isReady = useAuthStore((s) => s.isReady);
  const accountId = useAuthStore((s) => s.accountId);
  const { data, isLoading } = useBillingStatus({ enabled: !!accountId });
  const loginStartedRef = useRef(false);

  useEffect(() => {
    if (isReady && !accountId && !loginStartedRef.current) {
      loginStartedRef.current = true;
      void instance.loginRedirect(loginRequest);
    }
  }, [isReady, accountId, instance]);

  if (!isReady || !accountId) return <p>Redirecting to sign in…</p>;
  if (isLoading || !data) return <p>Getting you set up…</p>;

  if (data.status === 'Active' || data.status === 'PastDue') {
    return <Navigate to="/dashboard" replace />;
  }
  return <Navigate to="/onboarding" replace />;
}
